import { Box } from "@mui/material";
import * as React from "react";
import { useEffect } from "react";

declare global {
  interface Window {
    adsbygoogle: {
      push: (args?: any) => void;
      loaded: boolean;
      requestNonPersonalizedAds?: number;
      pageState?: string;
    };
  }
}

const AdsComponent = ({ show }: { show?: boolean }) => {
  useEffect(() => {
    try {
      const defaultValue = {
        push: () => {},
        requestNonPersonalizedAds: 1,
        pageState: "[]",
        loaded: false,
      };
      (window.adsbygoogle = window.adsbygoogle || defaultValue).push({});
    } catch (error) {}
  }, []);

  if (!show) {
    return <></>;
  }

  return (
    <Box
      sx={{
        margin: "12px 0",
        display: "block",
      }}
    >
      <ins
        className="adsbygoogle"
        style={{ display: "block", textAlign: "center", width: "100%" }}
        data-ad-client="ca-pub-2567516850189782"
        data-ad-slot="7163551361"
        data-ad-format="auto"
        data-full-width-responsive="true"
      ></ins>
      {/* <Box id="container-bb73779c75cba6413698dcc44390d06f"></Box> */}
    </Box>
  );
};

export default AdsComponent;
